import { createApplicationStore } from "app/entities/form-controller/model";
import { JobDescriptionRequestKzm } from "cuba/entities/kzm_JobDescriptionRequestKzm";

export const createJobDescriptionRequestStore = (
  idRequest: string,
  defaultValues: Record<string, any> = {},
) =>
  createApplicationStore<JobDescriptionRequestKzm>({
    application: {
      initialLoad: {
        entityName: JobDescriptionRequestKzm.NAME,
        id: idRequest,
        view: "jobDescriptionRequest-edit",
      },
      defaultValues,
      pathRedirect: "jobDescriptionRequest",
      baseFields: [
        "requestNumber",

        "requestDate",

        "status",

        "positionGroup",

        "compulsoryQualificationRequirements",

        "comment",

        "description",

        "file",

        "ruFiles",

        "kzFiles",

        "enFiles",

        "responsibilities",

        "renderQualificationRequirements",

        "renderBasicInteractions",

        "positionDuties",

        "objectivePosition",

        "generalAdditionalRequirements",

        "basicInteractionsAtWork",
      ],
    },
    bpm: {
      processDefinitionKey: "jobDescriptionRequest",
    },
  });
